import React from "react";
import { WHOLESALER_RETENTIONS_LABELS } from "./labels";
import { formatNumber } from "helpers/getNumberFormats";
import { newDate } from "helpers/dateTools";

const { headers } = WHOLESALER_RETENTIONS_LABELS;

export const detailColumns = [
  {
    Header: headers.date,
    accessor: "created",
    filterable: true,
    Cell: ({ value }) => <div>{value ? newDate({ date: value }) : ""}</div>,
  },
  {
    Header: headers.folio,
    accessor: "manualNoteFolio",
    filterable: true,
  },
  {
    Header: headers.amount,
    accessor: "amount",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: ({data}) =>  <div>Cantidad {data[0]?._original.unitMeasure || "KGS / LTS"}</div>,
    accessor: "quantity",
    filterable: true,
    Cell: ({ value }) => <div>{formatNumber(value)}</div>,
  },
];
